/**
 * Presentational component for the table body.
 */

import TableValue from './TableValue';
import type { TableColumn } from '../../types/TableColumn';
import { OrderItemTime } from '@/types/OrderItemTime';

import React from 'react';
export default function TableBodyItemTimes({
  data,
  columns,
}: {
  data: OrderItemTime[];
  columns: Array<TableColumn>;
}): JSX.Element {

  return (
    <tbody className="divide-y divide-gray-200 dark:divide-slate-700 text-xs bg-white dark:bg-[#182235] border-slate-200 dark:border-slate-700">
  {data.map((row, i) => {
    
    return (
      <React.Fragment key={i}>
        {/* Main Row */}
        <tr
          data-cy={`row-${i}`}
          className={`${
            'hover:bg-gray-100 dark:hover:bg-slate-800'
          } cursor-pointer relative group`}
        >
          {columns.map((col) => {
            // If the column has a custom render function, use it.
        

            // Otherwise, fall back to the original TableValue component.
            const value = row[col.key as keyof OrderItemTime];
            let href = col.href;


            return (
              <TableValue
                key={col.key}
                value={value}
                column={col}
                href={href}
              />
            );
          })}
        </tr>


      
      </React.Fragment>
    );
  })}
</tbody>

  );
}
